import type { TeamMember } from '@/types/team';

/**
 * Returns a shortened display name for a team member.
 * - If firstName AND lastName exist: "FirstWord FirstWord" (e.g., "Jean Pierre De La Cruz" → "Jean De")
 * - If only firstName: first word of firstName
 * - If only lastName: first word of lastName
 * - Otherwise: username or email prefix
 */
export function getDisplayName(member: TeamMember): string {
  const firstName = member.firstName?.trim();
  const lastName = member.lastName?.trim();

  if (firstName && lastName) {
    return `${firstName.split(' ')[0]} ${lastName.split(' ')[0]}`;
  }
  if (firstName) return firstName.split(' ')[0];
  if (lastName) return lastName.split(' ')[0];
  return member.username || member.email.split('@')[0];
}
